export default __webpack_public_path__ + "static/media/collectible-final-common.32be312b.jpg";